module.exports = __webpack_public_path__ + "linea-software-10.14427f95ed19faa7678d.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-software-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-software-10.svg
// module chunks = styles